/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Mobile_Downloading_PercentInputs */

const en_mobile_downloading_percent = /** @type {(inputs: Mobile_Downloading_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Downloading ${i?.percent}%`)
};

const es_mobile_downloading_percent = /** @type {(inputs: Mobile_Downloading_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descargando ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Downloading {percent}%" |
*
* @param {Mobile_Downloading_PercentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_downloading_percent = /** @type {((inputs: Mobile_Downloading_PercentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Downloading_PercentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_downloading_percent(inputs)
	return en_mobile_downloading_percent(inputs)
});